/**
 * The Gun Game weapon ladders — ordered weakest → strongest, ending in the
 * knife. Same ladder for every player in a match; the server owns each
 * player's tier. Room hosts may pick a ladder variant.
 */
export const LADDERS = {
    standard: {
        id: "standard",
        displayName: "Standard Purge (13 tiers)",
        weaponIds: [
            "pistol",
            "machine_pistol",
            "smg",
            "pump_shotgun",
            "shotgun",
            "carbine",
            "rifle",
            "burst_rifle",
            "lmg",
            "dmr",
            "sniper",
            "magnum",
            "ballistic",
        ],
    },
    sprint: {
        id: "sprint",
        displayName: "Sprint (8 tiers)",
        weaponIds: ["pistol", "smg", "pump_shotgun", "shotgun", "rifle", "sniper", "magnum", "ballistic"],
    },
    duel: {
        id: "duel",
        displayName: "Duel (2 tiers)",
        weaponIds: ["pistol", "ballistic"],
    },
};
export const DEFAULT_LADDER_ID = "standard";
export function ladderOrDefault(id) {
    return (id && LADDERS[id]) || LADDERS[DEFAULT_LADDER_ID];
}
/**
 * DESCENT — reverse Gun Game. The GUN rungs run strongest → weakest instead of
 * weakest → strongest, but the final melee/thrown rung (the ballistic knife)
 * stays last, so the iconic "final knife kill wins the match" finale is
 * preserved unchanged. You spawn with the strongest gun and every kill hands
 * you a WEAKER one — leading is a handicap, which turns the whole round into
 * pure comeback pressure. Runs entirely under Gun Game's existing rules; ONLY
 * the ladder order changes. The `id` is kept identical to the base so the
 * replicated `state.ladderId` still round-trips and the client re-derives the
 * exact same effective ladder from `(ladderId, mode)`.
 */
export function descentLadder(base) {
    const ids = base.weaponIds;
    // A 2-rung ladder is [gun, knife]; reversing its single gun is a no-op.
    if (ids.length <= 2)
        return base;
    const last = ids[ids.length - 1];
    const guns = ids.slice(0, ids.length - 1).reverse();
    return { ...base, weaponIds: [...guns, last] };
}
/**
 * The effective ladder for a room. DESCENT reverses the chosen ladder's gun
 * rungs; every other mode uses it exactly as authored. BOTH the server
 * (authority: `weaponForTier`, win check) and the client (the HUD ladder) call
 * this, so weapon-per-tier is bit-identical on the two sides — the reversal
 * lives in one shared place and cannot drift.
 */
export function resolveLadder(id, mode) {
    const base = ladderOrDefault(id);
    return mode === "descent" ? descentLadder(base) : base;
}
//# sourceMappingURL=ladder.js.map